var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile__detail"},[_c('h2',[_vm._v(_vm._s(_vm.newsItem.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.newsItem.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }